<template >
  <div class="table-container pull-auto">
    <avue-crud ref="crud"
               :page="page"
               :data="tableData"
               :table-loading="tableLoading"
               :option="tableOption"
               @size-change="sizeChange"
               @current-change="currentChange">

      <template slot-scope="scope" slot="menu">
        <el-button type="success" icon="el-icon-edit" size="mini"  @click="handleDown(scope.row,scope.index)">代码生成</el-button>
              </template>
    </avue-crud>
    <el-dialog title="生成配置" :visible.sync="box" width="50%" lock-scroll>
      <div class="pull-auto">
        <avue-form :option="formOption" ref="formData" v-model="formData" >
          <template slot="menuForm" slot-scope="scope">
             <el-button type="primary" icon="el-icon-plus" :loading="btnLoading" size="mini" @click="handleCodeGen()">{{submitText}}</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchList, handleDownload } from '@/api/admin/codegen'
import { tableOption, formOption } from '@/const/crud/codegen'
import { mapGetters } from 'vuex'
import { objKeySort } from '@/util/ajaxsign'
export default {
  name: 'codegen',
  data() {
    return {
      tableData: [],
      formData: {},
      submitText: '生成',
      box: false,
      addBtn: false,
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示多少条
      },
      listQuery: {
        current: 1,
        size: 20,
        tableName: undefined
      },
      tableLoading: false,
      btnLoading: false,
      tableOption: tableOption,
      formOption: formOption
    }
  },
  created() {
    this.getList()
  },
  mounted: function() {},
  computed: {
    ...mapGetters(['permissions'])
  },
  methods: {
    getList() {
      this.tableLoading = true
      fetchList(objKeySort({
        current: this.page.currentPage,
        size: this.page.pageSize
      })).then(response => {
        this.tableData = response.data.data.records
        this.page.total = response.data.data.total
        this.tableLoading = false
      })
    },
    currentChange(val) {
      this.page.currentPage = val
      this.getList()
    },
    sizeChange(val) {
      console.log(val)
      this.page.pageSize = val
      this.getList()
    },
    handleDown: function(row, index) {
      this.formData.tableName = row.tableName
      this.box = true
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleCodeGen() {
      this.btnLoading = true
      this.submitText = '代码生成中....'

      handleDownload(this.formData).then(response => {
        this.btnLoading = false
        this.$message({
          showClose: true,
          message: '代码生成成功,下载中....',
          type: 'success'
        })
          this.box = false
        this.submitText = '生成'

      }).cache(() => {
        this.$message({
          title: '失败',
          message: '代码生成失败',
          type: 'error',
          duration: 2000
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .avue-crud ::v-deep .avue-crud__menu{
    min-height: auto !important;
    margin-bottom: 0px !important;
  }
</style>

